<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Edit Affiliate Details</h1>
    </div>

    <div class="separator-breadcrumb border-top"></div>

    <div class="row">
      <div class="col-md-8 offset-md-2">
        <div class="card mb-4">
          <div class="card-body">
            <!-- Form -->
            <div class="form-group mb-3">
              <label for="full-name">Name</label>
              <input class="form-control" type="text" v-model="data.name" />
            </div>

             <div class="form-group">
              <!-- <label for="contact_no">Contact</label> -->
               <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <!-- cashout at -->
                  <div class="form-group">
                    <label for="date">Mobile Number</label>
                    <input
                      class="form-control"
                      type="text"
                      v-model="data.mobile_no"
                    />
                  </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <div class="form-group">
                    <label for="payment">Office Number</label>
                    <input
                      class="form-control"
                      type="text"
                      v-model="data.office_no"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group mb-3">
              <label for="email">Email</label>
              <input class="form-control" type="email" v-model="data.email" />
            </div>

            <div class="form-group mb-3">
              <label for="address">Address</label>
              <input class="form-control" type="text" v-model="data.address" />
            </div>

            <div class="form-group mb-3">
              <label for="facebook">Facebook</label>
              <input class="form-control" type="text" v-model="data.facebook" placeholder="https://www.facebook.com"/>
            </div>

            <div class="form-group mb-3">
              <label for="instagram">Instagram</label>
              <input class="form-control" type="text" v-model="data.instagram" placeholder="https://www.instagram.com" />
            </div>

            <div>
              <label for="status">Status</label>
              <select class="form-control" v-model="data.status">
                <option value="0">Inactive</option>
                <option value="1">Active</option>
              </select>
            </div>

            <!-- Button -->
            <div class="text-center mt-4">
              <button
                @click="submit()"
                class="btn btn-rounded btn-primary"
                style="width: 100px;"
              >
                Update
              </button>
            </div>

            <loading
              :active.sync="isLoading"
              :can-cancel="false"
              :is-full-page="fullPage"
            ></loading>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "affiliate-edit",
  components: {
    Loading
  },
  data() {
    return {
      data: {},
      isLoading: false,
      fullPage: true,
    };
  },

  methods: {
    async loadDetail() {
      let token = localStorage.getItem("token");
      let id = this.$route.params.id;

      if(token === null || token === '') {
        console.log('You are unauthorised')
        return;
      }

      token = JSON.parse(token);
      token = token.access_token;

      try {
        let result = await axios.get(axios.lpsURL + `/affiliate/${id}`, {
          headers: {
            Authorization: "Bearer " + token
          }
        });


        this.data = result.data;

      } catch (error) {
        console.log(error);
      }
    },

    async update() {
      let token = localStorage.getItem("token");
      let id = this.$route.params.id;

      if(token === null || token === '') {
        console.log('You are unauthorised')
        return;
      }

      token = JSON.parse(token);
      token = token.access_token;

      try {
        let result = await axios.post(axios.lpsURL + `/affiliate/${id}`, this.post_request(), {
          headers: {
            Authorization: "Bearer " + token
          }
        });

        swal({
          icon: result.data.success ? 'success' : 'error',
          text: result.data.message 
        })

      } catch (error) {
        console.log(error);
      }
    },

    post_request() {
      return {
        name: this.data.name,
        mobile_no: this.data.mobile_no,
        office_no: this.data.office_no,
        email: this.data.email,
        address: this.data.address,
        facebook: this.data.facebook,
        instagram: this.data.instagram,
        status: this.data.status,
        _method: "PATCH"
      }
    },

    async submit() {
      this.isLoading = true;
      this.update();
      this.isLoading = false;
    },

    lps() {
      return this.$lps();
    }
  },

  async created() {
    this.isLoading = true;
    await this.loadDetail();
    this.isLoading = false;
  }
};
</script>
